import { IBaseItem, ICartEntry } from '@rbi-ctg/menu';

export const existsInEntries = (item: IBaseItem, entries: ICartEntry[]): boolean =>
  entries.some(
    (entry: ICartEntry) =>
      item._id === entry._id ||
      (entry.children.length ? existsInEntries(item, entry.children) : false)
  );
